import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { selectEntitiesByFilters } from '../../../../shared/store/views/entityView';
import { coursesInActiveFilters, courseToAssignFilters, oldCoursesFilters } from '../../../../shared/utils/entitiesFiltersUtils';
import AssignStudyGroupSections from './assignStudyGroupPopup/assignStudyGroupsSections/AssignStudyGroupSections';
import AssignPopupHeader from './assignPopupHeader/AssignPopupHeader';
import pathRouts from '../../../../shared/enums/pathRoute';
import Page from '../../../../shared/components/ui/page/Page';
import classes from './AssignStudyGroupPage.module.css';
import { deviceTypes } from '../../../../shared/enums/deviceTypes';

const AssignStudyGroupPage = () => {

    const navigate = useNavigate();
    const { texts } = useSelector(state => state.translate);
    const deviceType = useSelector(state => state.responsive.deviceType);
    const coursesToAssign = useSelector(state => selectEntitiesByFilters(state, courseToAssignFilters));
    const inactiveCourses = useSelector(state => selectEntitiesByFilters(state, coursesInActiveFilters));
    const oldCourses = useSelector(state => selectEntitiesByFilters(state, oldCoursesFilters));

    return (
        <Page
            title={texts.assignWidgetTeacher}
            onBack={() => navigate(`/${pathRouts.MYLEARNING}`)}
        >
            <div className={classes.AssignStudyGroupPage}>
                <AssignPopupHeader countStudyGroup={30} />
                <div className={classes.Content}>
                    <AssignStudyGroupSections list={coursesToAssign} title={texts.studyGroupsToAssign} options={true} />
                    <AssignStudyGroupSections list={inactiveCourses} title={texts.studyGroupsInactiv} collapse={deviceType != deviceTypes.mobile && true} options={true} />
                    <AssignStudyGroupSections list={oldCourses} title={texts.studyGroupOld} collapse={deviceType != deviceTypes.mobile && true} options={false} />
                </div>
            </div>
        </Page>
    );
};

export default AssignStudyGroupPage;
